import { mapColourEnrichmentsToSwatchesMap } from "./mapColourEnrichmentsToSwatchesMap";

export const receiveColourEnrichment = (state, { payload }) => {
  const swatchesMap = mapColourEnrichmentsToSwatchesMap({
    enrichments: payload.items[0].facetValues
  });

  return {
    ...state,
    swatches: swatchesMap
  };
};
